Monitoring.Views ||= {}

class Monitoring.Views.ArrivalAlertsListView extends Backbone.View
  template: JST["backbone/templates/monitoring/arrival_alerts/arrival_alerts_list"]

  events:
    'click .edit-arrival-alert': 'onClickEdit'
    'click .delete-arrival-alert': 'onClickDelete'

  initialize: (@options = {}) ->
    @arrivalAlerts     = @options.arrivalAlerts
    @availableTopics   = @options.availableTopics
    @availableTags     = @options.availableTags
    @availableGroups   = @options.availableGroups
    @availableSubtypes = @options.availableSubtypes
    @currentUser       = @options.currentUser

  render: =>
    @$el.html(@template(@))
    @

  onClickEdit: (evt) ->
    alertId = $(evt.currentTarget).data('id')
    alert_to_edit = @arrivalAlerts.get(alertId)
    @trigger('edit', alert_to_edit)

  onClickDelete: (evt) ->
    swal({
        title: I18n.t('monitoring.arrival_alerts.confirmation.are_you_sure')
        type: 'warning'
        showCancelButton: true
        confirmButtonClass: 'btn-danger'
        confirmButtonText: I18n.t('monitoring.arrival_alerts.confirmation.confirm')
        cancelButtonText: I18n.t('monitoring.arrival_alerts.confirmation.cancel')
        closeOnConfirm: true
      }, =>
        alertId = $(evt.currentTarget).data('id')
        alertToDelete = @arrivalAlerts.get(alertId)
        alertToDelete.destroy(
          success: (response) =>
            console.log("Deleted alert #{alertToDelete.get('name')}")
            @arrivalAlerts.remove(alertToDelete)
            @render()
          error: (response) =>
            console.log("Error deleting alert #{alertToDelete.get('name')}")
        )
    )

  getConditionsAsText: (alert) ->
    _.filter([
      @getTopicsString(alert),
      @getTagsString(alert),
      @getGroupsString(alert),
      @getSubtypesString(alert),
      @getOwnershipString(alert),
      @getAuthorsString(alert),
      @getExcludedAuthorsString(alert),
      @getLocationsString(alert),
      @getMentionsString(alert),
      @getMinFollowersString(alert),
      @getNewsSourcesString(alert),
      @getSentimentsString(alert)
    ], (str) -> str != "").join('<br>')

  getTopicsString: (alert) ->
    if alert.get('topics').length > 0
      topicNames = _.map(alert.get('topics'), (id) =>
        found = _.find(@availableTopics, (topic) ->
          topic.id == parseInt(id)
        )
        if found then found.name else '(deleted)'
      )
      foundTopicNames = _.filter(topicNames, (name) -> name != '(deleted)')
      "#{I18n.t('monitoring.arrival_alerts.fields.topics')}: #{foundTopicNames.join(', ')}"
    else
      ""

  getTagsString: (alert) ->
    if alert.get('tags').length > 0
      tagDescriptions = _.map(alert.get('tags'), (clientCode) =>
        matchingTag = _.find(@availableTags, (tag) -> tag.code == clientCode)
        (matchingTag || {description: clientCode}).description
      )
      "#{I18n.t('monitoring.arrival_alerts.fields.tags')}: #{tagDescriptions.join(', ')}"
    else
      ""

  getGroupsString: (alert) ->
    if alert.get('groups').length > 0
      groupNames = alert.get('groups')
      "#{I18n.t('monitoring.arrival_alerts.fields.groups')}: #{groupNames.join(', ')}"
    else
      ""

  getSubtypesString: (alert) ->
    if alert.get('subtypes').length > 0
      subtypeNames = _.map(alert.get('subtypes'), (code) =>
        _.find(@availableSubtypes, (subtype) -> subtype.code == code).name
      )
      "#{I18n.t('monitoring.arrival_alerts.fields.types')}: #{subtypeNames.join(', ')}"
    else
      ""

  getOwnershipString: (alert) ->
    if alert.get('ownership') == 'own-content'
      I18n.t('monitoring.arrival_alerts.fields.only_own_content')
    else if alert.get('ownership') == 'not-own-content'
      I18n.t('monitoring.arrival_alerts.fields.exclude_own_content')
    else
      ""

  getAuthorsString: (alert) ->
    if alert.get('authors').length > 0
      "#{I18n.t('monitoring.arrival_alerts.fields.authors')}: #{alert.get('authors').join(', ')}"
    else
      ""

  getExcludedAuthorsString: (alert) ->
    if alert.get('excluded_authors').length > 0
      "#{I18n.t('monitoring.arrival_alerts.fields.excluded_authors')}: #{alert.get('excluded_authors').join(', ')}"
    else
      ""

  getLocationsString: (alert) ->
    if alert.get('locations').length > 0
      "#{I18n.t('monitoring.arrival_alerts.fields.locations')}: #{alert.get('locations').join(', ')}"
    else
      ""

  getMentionsString: (alert) ->
    if alert.get('mentions').length > 0
      "#{I18n.t('monitoring.arrival_alerts.fields.mentions')}: #{alert.get('mentions').join(', ')}"
    else
      ""

  getMinFollowersString: (alert) ->
    if alert.get('min_followers')
      "#{I18n.t('monitoring.arrival_alerts.fields.minimum_followers')}: #{alert.get('min_followers')}"
    else
      ""

  getNewsSourcesString: (alert) ->
    if alert.get('news_sources').length > 0
      "#{I18n.t('monitoring.arrival_alerts.fields.news_sources')}: #{alert.get('news_sources').join(', ')}"
    else
      ""

  getSentimentsString: (alert) ->
    alert_sentiments = alert.get('sentiments')
    if alert_sentiments.length > 0
      translated_alert_sentiments = _.map(alert_sentiments, (s) ->
        I18n.t('monitoring.arrival_alerts.sentiments.' + s)
      )
      "#{I18n.t('monitoring.arrival_alerts.fields.sentiments')}: #{translated_alert_sentiments.join(', ')}"
    else
      ""
